import * as React from "react";
const AccessibilityIllustration = (props) => (
  <svg
    width={422}
    height={317}
    viewBox="0 0 422 317"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#clip0_6063_36504)">
      <g filter="url(#filter0_dd_6063_36504)">
        <rect
          x={59.7979}
          y={47.1832}
          width={277.549}
          height={194.285}
          rx={6.66118}
          fill="white"
        />
      </g>
      <path
        d="M120.262 64.6273C180.48 64.6273 229.297 54.1985 229.297 41.334C229.297 28.4694 180.48 18.0406 120.262 18.0406C60.0433 18.0406 11.2266 28.4694 11.2266 41.334C11.2266 54.1985 60.0433 64.6273 120.262 64.6273Z"
        stroke="#D1ECFE"
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M120.262 87.9209C180.48 87.9209 229.297 77.4921 229.297 64.6276C229.297 51.763 180.48 41.3342 120.262 41.3342C60.0433 41.3342 11.2266 51.763 11.2266 64.6276C11.2266 77.4921 60.0433 87.9209 120.262 87.9209Z"
        stroke="#D1ECFE"
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M120.262 111.193C180.48 111.193 229.297 100.764 229.297 87.8993C229.297 75.0347 180.48 64.606 120.262 64.606C60.0433 64.606 11.2266 75.0347 11.2266 87.8993C11.2266 100.764 60.0433 111.193 120.262 111.193Z"
        stroke="#D1ECFE"
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M120.262 134.486C180.48 134.486 229.297 124.058 229.297 111.193C229.297 98.3286 180.48 87.8998 120.262 87.8998C60.0433 87.8998 11.2266 98.3286 11.2266 111.193C11.2266 124.058 60.0433 134.486 120.262 134.486Z"
        stroke="#D1ECFE"
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M120.262 157.78C180.48 157.78 229.297 147.351 229.297 134.486C229.297 121.622 180.48 111.193 120.262 111.193C60.0433 111.193 11.2266 121.622 11.2266 134.486C11.2266 147.351 60.0433 157.78 120.262 157.78Z"
        stroke="#D1ECFE"
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M219.965 270.992H110.451C93.8396 270.992 79.6013 260.709 73.752 246.158M219.965 270.992C195.527 270.992 189.428 292.537 189.428 292.537M219.965 270.992C195.527 270.992 189.428 249.447 189.428 249.447"
        stroke="#D1ECFE"
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M219.965 270.992H110.451C93.8396 270.992 79.6013 260.709 73.752 246.158M219.965 270.992C195.527 270.992 189.428 292.537 189.428 292.537M219.965 270.992C195.527 270.992 189.428 249.447 189.428 249.447"
        stroke="#18A0FB"
        strokeOpacity={0.2}
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M254.947 22.7024H342.146C363.94 22.7024 381.676 40.4378 381.676 62.2324V122.551"
        stroke="#D1ECFE"
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M254.947 22.7024H342.146C363.94 22.7024 381.676 40.4378 381.676 62.2324V122.551"
        stroke="#18A0FB"
        strokeOpacity={0.2}
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M381.664 124.717C383.147 124.717 384.35 123.514 384.35 122.031C384.35 120.548 383.147 119.346 381.664 119.346C380.181 119.346 378.979 120.548 378.979 122.031C378.979 123.514 380.181 124.717 381.664 124.717Z"
        fill="#18A0FB"
      />
      <path
        d="M254.946 25.3871C256.429 25.3871 257.631 24.1848 257.631 22.7018C257.631 21.2187 256.429 20.0165 254.946 20.0165C253.463 20.0165 252.261 21.2187 252.261 22.7018C252.261 24.1848 253.463 25.3871 254.946 25.3871Z"
        fill="#18A0FB"
      />
      <rect
        x={59.7979}
        y={70.775}
        width={202.611}
        height={95.7545}
        fill="white"
      />
      <path
        d="M65.9853 48.5712H331.16C334.583 48.5712 337.347 50.4158 337.347 52.7009V70.7751H59.7979V52.7009C59.7979 50.4158 62.5822 48.5712 65.9853 48.5712Z"
        fill="white"
        stroke="#E5E5E5"
        strokeWidth={0.693873}
        strokeMiterlimit={10}
      />
      <path
        d="M73.6749 62.4487C75.2078 62.4487 76.4504 61.2061 76.4504 59.6732C76.4504 58.1403 75.2078 56.8977 73.6749 56.8977C72.142 56.8977 70.8994 58.1403 70.8994 59.6732C70.8994 61.2061 72.142 62.4487 73.6749 62.4487Z"
        stroke="#231F20"
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M83.3891 62.4487C84.922 62.4487 86.1646 61.2061 86.1646 59.6732C86.1646 58.1403 84.922 56.8977 83.3891 56.8977C81.8563 56.8977 80.6136 58.1403 80.6136 59.6732C80.6136 61.2061 81.8563 62.4487 83.3891 62.4487Z"
        stroke="#231F20"
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M93.1034 62.4487C94.6362 62.4487 95.8789 61.2061 95.8789 59.6732C95.8789 58.1403 94.6362 56.8977 93.1034 56.8977C91.5705 56.8977 90.3279 58.1403 90.3279 59.6732C90.3279 61.2061 91.5705 62.4487 93.1034 62.4487Z"
        stroke="#231F20"
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M74.4798 95.2649V86.7164H74.2439L72.7867 89.8943H71.0798L73.1476 85.5507H76.0896V95.2649H74.4798ZM81.3746 95.4592C80.6252 95.4592 79.9776 95.325 79.4318 95.0567C78.8952 94.7884 78.4789 94.4091 78.1828 93.9188C77.8868 93.4284 77.7387 92.8595 77.7387 92.2118V92.0731H79.3763V92.198C79.3763 92.7253 79.5428 93.1601 79.8759 93.5025C80.2182 93.8448 80.7085 94.0159 81.3469 94.0159C81.9852 94.0159 82.4802 93.8401 82.8318 93.4886C83.1833 93.137 83.3591 92.6744 83.3591 92.1008V91.9759C83.3591 91.4116 83.1833 90.9629 82.8318 90.6298C82.4894 90.2968 82.0546 90.1302 81.5273 90.1302C81.2312 90.1302 80.9861 90.1719 80.7918 90.2551C80.6067 90.3384 80.4541 90.4448 80.3338 90.5743C80.2135 90.6946 80.1164 90.8195 80.0424 90.949H78.044V85.5507H84.6081V87.0217H79.6538V89.6306H79.8897C79.9915 89.4919 80.121 89.3623 80.2783 89.2421C80.4448 89.1125 80.6576 89.0062 80.9167 88.9229C81.185 88.8304 81.5041 88.7841 81.8742 88.7841C82.4478 88.7841 82.9659 88.909 83.4285 89.1588C83.9003 89.3993 84.275 89.7555 84.5526 90.2274C84.8301 90.6992 84.9689 91.2774 84.9689 91.9621V92.1147C84.9689 92.7901 84.8255 93.3776 84.5387 93.8771C84.2519 94.3767 83.8402 94.7653 83.3036 95.0429C82.767 95.3204 82.124 95.4592 81.3746 95.4592ZM90.8267 95.2649V93.2943H85.9696V91.4208L89.5083 85.5507H92.4365V91.851H94.0602V93.2943H92.4365V95.2649H90.8267ZM87.5239 91.851H90.8267V86.5776H90.5908L87.5239 91.6429V91.851Z"
        fill="#24292F"
      />
      <path
        d="M71.3435 103.142V99.2566H71.8098V103.142H71.3435ZM73.8089 103.22C73.4722 103.22 73.1872 103.142 72.9541 102.987C72.7246 102.831 72.5858 102.585 72.5377 102.249L72.9541 102.154C72.9837 102.332 73.0392 102.473 73.1206 102.576C73.202 102.676 73.3019 102.748 73.4203 102.793C73.5425 102.833 73.672 102.854 73.8089 102.854C74.0124 102.854 74.1734 102.813 74.2918 102.732C74.4103 102.65 74.4695 102.541 74.4695 102.404C74.4695 102.263 74.4121 102.165 74.2974 102.11C74.1864 102.051 74.0328 102.003 73.8367 101.966L73.6091 101.927C73.4351 101.897 73.276 101.851 73.1317 101.788C72.9874 101.725 72.8726 101.64 72.7875 101.533C72.7024 101.425 72.6599 101.29 72.6599 101.127C72.6599 100.883 72.7542 100.692 72.943 100.556C73.1317 100.419 73.3815 100.35 73.6923 100.35C73.9995 100.35 74.2474 100.42 74.4362 100.561C74.6286 100.698 74.7526 100.892 74.8081 101.144L74.3973 101.249C74.364 101.053 74.2844 100.916 74.1586 100.839C74.0328 100.757 73.8774 100.717 73.6923 100.717C73.5073 100.717 73.3611 100.752 73.2538 100.822C73.1465 100.889 73.0928 100.989 73.0928 101.122C73.0928 101.251 73.1428 101.348 73.2427 101.41C73.3463 101.47 73.4833 101.514 73.6535 101.544L73.8811 101.583C74.0735 101.616 74.2456 101.662 74.3973 101.721C74.5527 101.777 74.6749 101.858 74.7637 101.966C74.8562 102.073 74.9025 102.213 74.9025 102.387C74.9025 102.654 74.8025 102.859 74.6027 103.004C74.4066 103.148 74.142 103.22 73.8089 103.22ZM76.7362 103.22C76.3994 103.22 76.1145 103.142 75.8813 102.987C75.6519 102.831 75.5131 102.585 75.465 102.249L75.8813 102.154C75.9109 102.332 75.9665 102.473 76.0479 102.576C76.1293 102.676 76.2292 102.748 76.3476 102.793C76.4697 102.833 76.5993 102.854 76.7362 102.854C76.9397 102.854 77.1007 102.813 77.2191 102.732C77.3375 102.65 77.3968 102.541 77.3968 102.404C77.3968 102.263 77.3394 102.165 77.2247 102.11C77.1137 102.051 76.9601 102.003 76.7639 101.966L76.5364 101.927C76.3624 101.897 76.2033 101.851 76.059 101.788C75.9146 101.725 75.7999 101.64 75.7148 101.533C75.6297 101.425 75.5871 101.29 75.5871 101.127C75.5871 100.883 75.6815 100.692 75.8702 100.556C76.059 100.419 76.3088 100.35 76.6196 100.35C76.9268 100.35 77.1747 100.42 77.3635 100.561C77.5559 100.698 77.6799 100.892 77.7354 101.144L77.3246 101.249C77.2913 101.053 77.2117 100.916 77.0859 100.839C76.9601 100.757 76.8047 100.717 76.6196 100.717C76.4346 100.717 76.2884 100.752 76.1811 100.822C76.0738 100.889 76.0201 100.989 76.0201 101.122C76.0201 101.251 76.0701 101.348 76.17 101.41C76.2736 101.47 76.4105 101.514 76.5808 101.544L76.8084 101.583C77.0008 101.616 77.1729 101.662 77.3246 101.721C77.48 101.777 77.6021 101.858 77.691 101.966C77.7835 102.073 77.8297 102.213 77.8297 102.387C77.8297 102.654 77.7298 102.859 77.53 103.004C77.3338 103.148 77.0693 103.22 76.7362 103.22ZM79.608 103.192C79.4118 103.192 79.2305 103.15 79.064 103.065C78.9011 102.98 78.7716 102.854 78.6754 102.687C78.5829 102.517 78.5366 102.312 78.5366 102.071V100.428H78.9751V102.038C78.9751 102.308 79.0418 102.504 79.175 102.626C79.3119 102.748 79.4951 102.809 79.7245 102.809C79.9836 102.809 80.1964 102.724 80.3629 102.554C80.5294 102.384 80.6127 102.13 80.6127 101.793V100.428H81.0512V103.142H80.6238V102.682H80.5461C80.4869 102.811 80.3851 102.93 80.2408 103.037C80.0964 103.14 79.8855 103.192 79.608 103.192ZM83.2122 103.22C82.9384 103.22 82.6978 103.163 82.4906 103.048C82.2834 102.93 82.1224 102.765 82.0077 102.554C81.893 102.343 81.8356 102.099 81.8356 101.821V101.755C81.8356 101.473 81.893 101.227 82.0077 101.016C82.1224 100.805 82.2815 100.643 82.4851 100.528C82.6886 100.409 82.9217 100.35 83.1845 100.35C83.4398 100.35 83.6656 100.406 83.8617 100.517C84.0578 100.624 84.2114 100.779 84.3224 100.983C84.4335 101.187 84.489 101.425 84.489 101.699V101.899H82.2741C82.2852 102.191 82.3796 102.421 82.5572 102.587C82.7349 102.75 82.9569 102.831 83.2233 102.831C83.4565 102.831 83.636 102.778 83.7618 102.671C83.8876 102.563 83.9838 102.436 84.0504 102.287L84.4279 102.471C84.3724 102.585 84.2947 102.7 84.1948 102.815C84.0985 102.93 83.9709 103.026 83.8117 103.103C83.6563 103.181 83.4565 103.22 83.2122 103.22ZM82.2797 101.538H84.0449C84.0301 101.286 83.9431 101.09 83.784 100.95C83.6286 100.809 83.4287 100.739 83.1845 100.739C82.9365 100.739 82.733 100.809 82.5739 100.95C82.4147 101.09 82.3167 101.286 82.2797 101.538ZM86.3474 103.22C86.0107 103.22 85.7257 103.142 85.4926 102.987C85.2631 102.831 85.1244 102.585 85.0762 102.249L85.4926 102.154C85.5222 102.332 85.5777 102.473 85.6591 102.576C85.7405 102.676 85.8404 102.748 85.9589 102.793C86.081 102.833 86.2105 102.854 86.3474 102.854C86.551 102.854 86.7119 102.813 86.8304 102.732C86.9488 102.65 87.008 102.541 87.008 102.404C87.008 102.263 86.9506 102.165 86.8359 102.11C86.7249 102.051 86.5713 102.003 86.3752 101.966L86.1476 101.927C85.9737 101.897 85.8145 101.851 85.6702 101.788C85.5259 101.725 85.4112 101.64 85.326 101.533C85.2409 101.425 85.1984 101.29 85.1984 101.127C85.1984 100.883 85.2927 100.692 85.4815 100.556C85.6702 100.419 85.92 100.35 86.2309 100.35C86.538 100.35 86.7859 100.42 86.9747 100.561C87.1671 100.698 87.2911 100.892 87.3466 101.144L86.9358 101.249C86.9025 101.053 86.823 100.916 86.6971 100.839C86.5713 100.757 86.4159 100.717 86.2309 100.717C86.0458 100.717 85.8996 100.752 85.7923 100.822C85.685 100.889 85.6313 100.989 85.6313 101.122C85.6313 101.251 85.6813 101.348 85.7812 101.41C85.8848 101.47 86.0218 101.514 86.192 101.544L86.4196 101.583C86.612 101.616 86.7841 101.662 86.9358 101.721C87.0913 101.777 87.2134 101.858 87.3022 101.966C87.3947 102.073 87.441 102.213 87.441 102.387C87.441 102.654 87.341 102.859 87.1412 103.004C86.9451 103.148 86.6805 103.22 86.3474 103.22ZM90.1397 103.142V100.811H89.3071V100.428H90.1397V99.734C90.1397 99.586 90.1805 99.4694 90.2619 99.3843C90.347 99.2992 90.4673 99.2566 90.6227 99.2566H91.3055V99.6341H90.7448C90.6338 99.6341 90.5783 99.6896 90.5783 99.8006V100.428H91.4331V100.811H90.5783V103.142H90.1397ZM93.1815 103.22C92.9077 103.22 92.6653 103.163 92.4543 103.048C92.2471 102.933 92.0843 102.772 91.9658 102.565C91.8511 102.354 91.7938 102.106 91.7938 101.821V101.749C91.7938 101.468 91.8511 101.222 91.9658 101.011C92.0843 100.8 92.2471 100.637 92.4543 100.522C92.6653 100.408 92.9077 100.35 93.1815 100.35C93.4554 100.35 93.6959 100.408 93.9031 100.522C94.1141 100.637 94.2769 100.8 94.3916 101.011C94.51 101.222 94.5693 101.468 94.5693 101.749V101.821C94.5693 102.106 94.51 102.354 94.3916 102.565C94.2769 102.772 94.1141 102.933 93.9031 103.048C93.6959 103.163 93.4554 103.22 93.1815 103.22ZM93.1815 102.826C93.4702 102.826 93.6996 102.735 93.8698 102.554C94.0438 102.369 94.1307 102.121 94.1307 101.81V101.76C94.1307 101.449 94.0438 101.203 93.8698 101.022C93.6996 100.837 93.4702 100.744 93.1815 100.744C92.8966 100.744 92.6671 100.837 92.4932 101.022C92.3193 101.203 92.2323 101.449 92.2323 101.76V101.81C92.2323 102.121 92.3193 102.369 92.4932 102.554C92.6671 102.735 92.8966 102.826 93.1815 102.826ZM96.3964 103.192C96.2003 103.192 96.019 103.15 95.8524 103.065C95.6896 102.98 95.5601 102.854 95.4639 102.687C95.3714 102.517 95.3251 102.312 95.3251 102.071V100.428H95.7636V102.038C95.7636 102.308 95.8302 102.504 95.9635 102.626C96.1004 102.748 96.2836 102.809 96.513 102.809C96.7721 102.809 96.9848 102.724 97.1514 102.554C97.3179 102.384 97.4012 102.13 97.4012 101.793V100.428H97.8397V103.142H97.4123V102.682H97.3346C97.2753 102.811 97.1736 102.93 97.0293 103.037C96.8849 103.14 96.674 103.192 96.3964 103.192ZM98.7573 103.142V100.428H99.1847V100.889H99.2624C99.3217 100.759 99.4216 100.643 99.5622 100.539C99.7065 100.432 99.9175 100.378 100.195 100.378C100.399 100.378 100.58 100.42 100.739 100.506C100.902 100.591 101.031 100.717 101.128 100.883C101.224 101.05 101.272 101.255 101.272 101.499V103.142H100.833V101.533C100.833 101.262 100.765 101.066 100.628 100.944C100.495 100.822 100.313 100.761 100.084 100.761C99.8212 100.761 99.6066 100.846 99.4401 101.016C99.2772 101.187 99.1958 101.44 99.1958 101.777V103.142H98.7573ZM103.311 103.22C103.078 103.22 102.863 103.165 102.667 103.054C102.471 102.942 102.315 102.782 102.2 102.571C102.086 102.36 102.028 102.11 102.028 101.821V101.749C102.028 101.46 102.086 101.212 102.2 101.005C102.315 100.794 102.469 100.633 102.661 100.522C102.857 100.408 103.074 100.35 103.311 100.35C103.499 100.35 103.659 100.376 103.788 100.428C103.921 100.476 104.029 100.539 104.11 100.617C104.191 100.691 104.254 100.77 104.299 100.855H104.376V99.2566H104.815V103.142H104.388V102.693H104.31C104.236 102.83 104.121 102.952 103.966 103.059C103.81 103.166 103.592 103.22 103.311 103.22ZM103.427 102.831C103.708 102.831 103.936 102.743 104.11 102.565C104.288 102.384 104.376 102.132 104.376 101.81V101.76C104.376 101.438 104.288 101.188 104.11 101.011C103.936 100.829 103.708 100.739 103.427 100.739C103.15 100.739 102.92 100.829 102.739 101.011C102.561 101.188 102.472 101.438 102.472 101.76V101.81C102.472 102.132 102.561 102.384 102.739 102.565C102.92 102.743 103.15 102.831 103.427 102.831Z"
        fill="#24292F"
      />
      <rect
        x={71.0729}
        y={112.581}
        width={23.2448}
        height={7.28567}
        rx={3.64284}
        stroke="#D0D7DE"
        strokeWidth={0.346937}
      />
      <path
        d="M74.9404 117.836L76.5595 115.061L78.1785 117.836H74.9404Z"
        fill="#D1242F"
      />
      <rect
        x={80.6133}
        y={115.53}
        width={11.102}
        height={1.38775}
        rx={0.693873}
        fill="#D9D9D9"
      />
      <rect
        x={97.4401}
        y={112.581}
        width={28.7957}
        height={7.28567}
        rx={3.64284}
        stroke="#D0D7DE"
        strokeWidth={0.346937}
      />
      <rect
        x={101.654}
        y={115.061}
        width={2.77549}
        height={2.77549}
        fill="#8250DF"
      />
      <rect
        x={106.98}
        y={115.53}
        width={16.653}
        height={1.38775}
        rx={0.693873}
        fill="#D9D9D9"
      />
      <rect
        x={71.0729}
        y={122.989}
        width={34.3467}
        height={7.28567}
        rx={3.64284}
        stroke="#D0D7DE"
        strokeWidth={0.346937}
      />
      <circle cx={76.6749} cy={126.857} r={1.38775} fill="#0969DA" />
      <rect
        x={80.6133}
        y={125.938}
        width={22.2039}
        height={1.38775}
        rx={0.693873}
        fill="#D9D9D9"
      />
      <rect
        x={108.542}
        y={122.989}
        width={23.2448}
        height={7.28567}
        rx={3.64284}
        stroke="#D0D7DE"
        strokeWidth={0.346937}
      />
      <circle
        cx={114.144}
        cy={126.857}
        r={1.12754}
        stroke="#24292F"
        strokeWidth={0.520405}
      />
      <rect
        x={118.082}
        y={125.938}
        width={11.102}
        height={1.38775}
        rx={0.693873}
        fill="#D9D9D9"
      />
      <path
        d="M331.349 54.1222H287.834C287.584 54.1222 287.388 54.3897 287.388 54.7302V64.6162C287.388 64.9566 287.584 65.2242 287.834 65.2242H331.349C331.599 65.2242 331.796 64.9566 331.796 64.6162V54.7302C331.796 54.3897 331.599 54.1222 331.349 54.1222Z"
        fill="white"
        stroke="#DDDDDD"
        strokeWidth={0.520406}
        strokeMiterlimit={10}
      />
      <path
        d="M326.244 57.9384L323.473 60.7138L320.693 57.9384"
        stroke="#231F20"
        strokeWidth={0.520406}
        strokeMiterlimit={10}
      />
      <path
        d="M329.02 95.5812H156.939V95.9281H329.02V95.5812Z"
        fill="#DDDDDD"
      />
      <path
        d="M158.502 90.8976L160.931 86.7344L163.359 90.8976H158.502Z"
        fill="#CF222E"
      />
      <rect
        x={168.041}
        y={87.4281}
        width={160.979}
        height={2.77549}
        rx={1.38775}
        fill="#E6E6E6"
      />
      <path
        d="M329.02 109.459H156.939V109.806H329.02V109.459Z"
        fill="#DDDDDD"
      />
      <path
        d="M158.502 104.775L160.931 100.612L163.359 104.775H158.502Z"
        fill="#CF222E"
      />
      <rect
        x={168.041}
        y={101.306}
        width={160.979}
        height={2.77549}
        rx={1.38775}
        fill="#E6E6E6"
      />
      <path
        d="M329.02 123.336H156.939V123.683H329.02V123.336Z"
        fill="#DDDDDD"
      />
      <rect
        x={159.021}
        y={114.489}
        width={4.16324}
        height={4.16324}
        fill="#8250DF"
      />
      <rect
        x={168.041}
        y={115.183}
        width={160.979}
        height={2.77549}
        rx={0.693873}
        fill="white"
      />
      <rect
        x={168.041}
        y={115.183}
        width={160.979}
        height={2.77549}
        rx={1.38775}
        fill="#E6E6E6"
      />
      <path d="M329.02 137.214H156.939V137.56H329.02V137.214Z" fill="#DDDDDD" />
      <rect
        x={159.021}
        y={128.367}
        width={4.16324}
        height={4.16324}
        fill="#8250DF"
      />
      <rect
        x={168.041}
        y={129.061}
        width={160.979}
        height={2.77549}
        rx={0.693873}
        fill="white"
      />
      <rect
        x={168.041}
        y={129.061}
        width={160.979}
        height={2.77549}
        rx={1.38775}
        fill="#E6E6E6"
      />
      <path
        d="M329.02 151.091H156.939V151.438H329.02V151.091Z"
        fill="#DDDDDD"
      />
      <rect
        x={159.021}
        y={142.244}
        width={4.16324}
        height={4.16324}
        fill="#8250DF"
      />
      <rect
        x={168.041}
        y={142.938}
        width={160.979}
        height={2.77549}
        rx={0.693873}
        fill="white"
      />
      <rect
        x={168.041}
        y={142.938}
        width={160.979}
        height={2.77549}
        rx={1.38775}
        fill="#E6E6E6"
      />
      <path
        d="M329.02 164.968H156.939V165.315H329.02V164.968Z"
        fill="#DDDDDD"
      />
      <circle cx={161.103} cy={158.203} r={2.08162} fill="#0969DA" />
      <rect
        x={168.041}
        y={157.509}
        width={160.979}
        height={1.38775}
        rx={0.346937}
        fill="white"
      />
      <path
        d="M168.041 159.591C168.041 158.824 168.662 158.203 169.429 158.203H294.326C295.092 158.203 295.714 158.824 295.714 159.591C295.714 160.357 295.092 160.979 294.326 160.979H169.429C168.662 160.979 168.041 160.357 168.041 159.591Z"
        fill="#E6E6E6"
      />
      <circle cx={161.103} cy={172.081} r={2.08162} fill="#0969DA" />
      <rect
        x={168.041}
        y={171.387}
        width={160.979}
        height={1.38775}
        rx={0.346937}
        fill="white"
      />
      <path
        d="M168.041 172.774C168.041 172.008 168.662 171.387 169.429 171.387H255.469C256.235 171.387 256.857 172.008 256.857 172.774C256.857 173.541 256.235 174.162 255.469 174.162H169.429C168.662 174.162 168.041 173.541 168.041 172.774Z"
        fill="#E6E6E6"
      />
      <circle cx={161.103} cy={185.958} r={2.08162} fill="#0969DA" />
      <rect
        x={168.041}
        y={185.264}
        width={160.979}
        height={1.38775}
        rx={0.346937}
        fill="white"
      />
      <path
        d="M168.041 186.652C168.041 185.886 168.662 185.264 169.429 185.264H255.469C256.235 185.264 256.857 185.886 256.857 186.652C256.857 187.418 256.235 188.04 255.469 188.04H169.429C168.662 188.04 168.041 187.418 168.041 186.652Z"
        fill="#E6E6E6"
      />
      <circle cx={161.103} cy={199.836} r={2.08162} fill="#0969DA" />
      <rect
        x={168.041}
        y={199.142}
        width={160.979}
        height={1.38775}
        rx={0.346937}
        fill="white"
      />
      <path
        d="M168.041 200.529C168.041 199.763 168.662 199.142 169.429 199.142H255.469C256.235 199.142 256.857 199.763 256.857 200.529C256.857 201.296 256.235 201.917 255.469 201.917H169.429C168.662 201.917 168.041 201.296 168.041 200.529Z"
        fill="#E6E6E6"
      />
      <g filter="url(#filter1_dd_6063_36504)">
        <rect
          x={204.124}
          y={41.6323}
          width={44.4079}
          height={43.0201}
          rx={5.55099}
          fill="#129ED9"
        />
        <path
          d="M226.327 55.5099C227.094 55.5099 227.715 54.8886 227.715 54.1221C227.715 53.3557 227.094 52.7344 226.327 52.7344C225.561 52.7344 224.939 53.3557 224.939 54.1221C224.939 54.8886 225.561 55.5099 226.327 55.5099Z"
          fill="white"
          stroke="white"
          strokeWidth={2.08162}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M222.164 74.9384L226.327 65.2241M226.327 65.2241L230.491 74.9384M226.327 65.2241V61.0609M218.001 58.2854L226.327 61.0609M226.327 61.0609L234.654 58.2854"
          stroke="white"
          strokeWidth={2.08162}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g filter="url(#filter2_dd_6063_36504)">
        <path
          d="M400.699 238.693H329.507C328.473 238.693 327.634 239.531 327.634 240.566V264.574C327.634 265.609 328.473 266.447 329.507 266.447H400.699C401.733 266.447 402.572 265.609 402.572 264.574V240.566C402.572 239.531 401.733 238.693 400.699 238.693Z"
          fill="white"
        />
        <path
          d="M329.507 239.039H400.699C401.542 239.039 402.225 239.723 402.225 240.566V264.574C402.225 265.417 401.542 266.101 400.699 266.101H329.507C328.664 266.101 327.981 265.417 327.981 264.574V240.566C327.981 239.723 328.664 239.039 329.507 239.039Z"
          stroke="#E5E5E5"
          strokeWidth={0.693873}
        />
      </g>
      <rect
        x={336.654}
        y={250.488}
        width={5.55099}
        height={5.55099}
        fill="#8250DF"
      />
      <path
        d="M352.419 255.911C351.975 255.911 351.581 255.833 351.237 255.678C350.898 255.517 350.632 255.286 350.437 254.987C350.243 254.687 350.146 254.321 350.146 253.888V253.671H351.137V253.888C351.137 254.271 351.253 254.556 351.487 254.745C351.72 254.934 352.031 255.028 352.419 255.028C352.813 255.028 353.11 254.948 353.31 254.787C353.51 254.626 353.61 254.418 353.61 254.162C353.61 253.99 353.563 253.851 353.468 253.746C353.374 253.635 353.235 253.546 353.052 253.48C352.874 253.413 352.658 253.349 352.402 253.288L352.153 253.238C351.77 253.149 351.437 253.038 351.153 252.905C350.876 252.766 350.662 252.589 350.512 252.372C350.362 252.156 350.288 251.873 350.288 251.523C350.288 251.173 350.371 250.873 350.537 250.624C350.704 250.374 350.94 250.182 351.245 250.049C351.55 249.916 351.908 249.849 352.319 249.849C352.73 249.849 353.096 249.919 353.418 250.057C353.74 250.196 353.993 250.404 354.176 250.682C354.365 250.959 354.459 251.306 354.459 251.723V251.997H353.468V251.723C353.468 251.484 353.421 251.292 353.327 251.148C353.232 251.004 353.099 250.898 352.927 250.832C352.755 250.765 352.552 250.732 352.319 250.732C351.975 250.732 351.714 250.798 351.536 250.932C351.359 251.065 351.27 251.254 351.27 251.498C351.27 251.653 351.309 251.786 351.387 251.898C351.47 252.003 351.589 252.092 351.745 252.164C351.906 252.231 352.105 252.289 352.344 252.339L352.594 252.397C352.994 252.486 353.343 252.6 353.643 252.738C353.943 252.872 354.176 253.049 354.343 253.271C354.515 253.493 354.601 253.782 354.601 254.137C354.601 254.487 354.509 254.795 354.326 255.062C354.148 255.328 353.896 255.536 353.568 255.686C353.246 255.836 352.863 255.911 352.419 255.911ZM357.393 255.911C356.983 255.911 356.619 255.825 356.303 255.653C355.992 255.475 355.747 255.228 355.57 254.912C355.398 254.59 355.312 254.215 355.312 253.788V253.688C355.312 253.255 355.398 252.88 355.57 252.564C355.742 252.247 355.983 252.003 356.294 251.831C356.605 251.653 356.963 251.564 357.368 251.564C357.768 251.564 358.118 251.653 358.417 251.831C358.717 252.003 358.95 252.247 359.117 252.564C359.283 252.88 359.367 253.249 359.367 253.671V254.012H356.278C356.289 254.334 356.402 254.593 356.619 254.787C356.835 254.981 357.102 255.078 357.418 255.078C357.729 255.078 357.96 255.012 358.109 254.878C358.259 254.74 358.373 254.584 358.451 254.412L359.242 254.82C359.164 254.97 359.05 255.131 358.9 255.303C358.756 255.47 358.562 255.614 358.318 255.736C358.073 255.853 357.765 255.911 357.393 255.911ZM356.286 253.288H358.393C358.37 253.016 358.265 252.8 358.076 252.639C357.893 252.478 357.654 252.397 357.36 252.397C357.055 252.397 356.81 252.478 356.627 252.639C356.444 252.8 356.33 253.016 356.286 253.288ZM360.35 255.794V251.681H361.291V252.156H361.432C361.493 251.984 361.596 251.859 361.74 251.781C361.885 251.703 362.057 251.664 362.256 251.664H362.756V252.514H362.24C361.962 252.514 361.737 252.589 361.565 252.738C361.393 252.883 361.307 253.108 361.307 253.413V255.794H360.35ZM363.602 255.794V251.681H364.56V255.794H363.602ZM364.077 251.156C363.905 251.156 363.755 251.101 363.627 250.99C363.505 250.873 363.444 250.721 363.444 250.532C363.444 250.343 363.505 250.193 363.627 250.082C363.755 249.966 363.905 249.907 364.077 249.907C364.26 249.907 364.41 249.966 364.526 250.082C364.649 250.193 364.71 250.343 364.71 250.532C364.71 250.721 364.649 250.873 364.526 250.99C364.41 251.101 364.26 251.156 364.077 251.156ZM367.722 255.911C367.311 255.911 366.942 255.828 366.614 255.661C366.292 255.489 366.037 255.248 365.848 254.937C365.665 254.62 365.573 254.243 365.573 253.804V253.671C365.573 253.233 365.665 252.855 365.848 252.539C366.037 252.222 366.292 251.981 366.614 251.814C366.942 251.648 367.311 251.564 367.722 251.564C368.132 251.564 368.499 251.648 368.821 251.814C369.143 251.981 369.395 252.222 369.578 252.539C369.767 252.855 369.862 253.233 369.862 253.671V253.804C369.862 254.243 369.767 254.62 369.578 254.937C369.395 255.248 369.143 255.489 368.821 255.661C368.499 255.828 368.132 255.911 367.722 255.911ZM367.722 255.062C368.071 255.062 368.357 254.951 368.579 254.729C368.801 254.501 368.912 254.185 368.912 253.779V253.696C368.912 253.291 368.801 252.977 368.579 252.755C368.357 252.528 368.071 252.414 367.722 252.414C367.372 252.414 367.086 252.528 366.864 252.755C366.642 252.977 366.531 253.291 366.531 253.696V253.779C366.531 254.185 366.642 254.501 366.864 254.729C367.086 254.951 367.372 255.062 367.722 255.062ZM372.453 255.861C372.137 255.861 371.857 255.792 371.612 255.653C371.368 255.508 371.18 255.309 371.046 255.053C370.913 254.792 370.846 254.49 370.846 254.146V251.681H371.796V254.071C371.796 254.404 371.876 254.651 372.037 254.812C372.204 254.973 372.437 255.053 372.737 255.053C373.075 255.053 373.342 254.942 373.536 254.72C373.736 254.498 373.836 254.179 373.836 253.763V251.681H374.785V255.794H373.852V255.22H373.711C373.639 255.37 373.505 255.514 373.311 255.653C373.122 255.792 372.836 255.861 372.453 255.861ZM377.701 255.911C377.168 255.911 376.73 255.794 376.386 255.561C376.041 255.328 375.833 254.987 375.761 254.537L376.644 254.312C376.682 254.523 376.752 254.69 376.852 254.812C376.952 254.934 377.074 255.02 377.218 255.07C377.368 255.12 377.529 255.145 377.701 255.145C377.962 255.145 378.156 255.098 378.284 255.003C378.417 254.909 378.484 254.79 378.484 254.645C378.484 254.495 378.42 254.384 378.292 254.312C378.17 254.24 377.981 254.179 377.726 254.129L377.468 254.087C377.185 254.032 376.927 253.957 376.694 253.863C376.46 253.763 376.272 253.629 376.127 253.463C375.989 253.291 375.919 253.074 375.919 252.813C375.919 252.414 376.066 252.106 376.361 251.889C376.66 251.673 377.052 251.564 377.535 251.564C377.995 251.564 378.376 251.667 378.675 251.873C378.975 252.078 379.169 252.353 379.258 252.697L378.376 252.963C378.331 252.73 378.234 252.566 378.084 252.472C377.934 252.372 377.751 252.322 377.535 252.322C377.313 252.322 377.14 252.361 377.018 252.439C376.902 252.516 376.843 252.627 376.843 252.772C376.843 252.916 376.905 253.024 377.027 253.097C377.149 253.169 377.313 253.221 377.518 253.255L377.776 253.305C378.081 253.36 378.356 253.432 378.6 253.521C378.85 253.61 379.047 253.738 379.192 253.904C379.336 254.071 379.408 254.296 379.408 254.579C379.408 255.006 379.253 255.336 378.942 255.569C378.636 255.797 378.223 255.911 377.701 255.911Z"
        fill="#24292F"
      />
      <g filter="url(#filter3_dd_6063_36504)">
        <path
          d="M354.903 277.549H300.364C299.329 277.549 298.491 278.388 298.491 279.423V297.88C298.491 298.915 299.329 299.753 300.364 299.753H354.903C355.937 299.753 356.776 298.915 356.776 297.88V279.423C356.776 278.388 355.937 277.549 354.903 277.549Z"
          fill="white"
        />
        <path
          d="M300.364 277.896H354.903C355.746 277.896 356.429 278.58 356.429 279.423V297.88C356.429 298.723 355.746 299.406 354.903 299.406H300.364C299.521 299.406 298.838 298.723 298.838 297.88V279.423C298.838 278.58 299.521 277.896 300.364 277.896Z"
          stroke="#E5E5E5"
          strokeWidth={0.693873}
        />
      </g>
      <path
        d="M314.139 290.876V286.99H315.388L316.143 290.426H316.237L316.998 286.99H318.241V290.876H317.597V287.473H317.503L316.748 290.876H315.638L314.883 287.473H314.788V290.876H314.139ZM320.333 290.953C320.06 290.953 319.813 290.898 319.595 290.787C319.38 290.672 319.21 290.511 319.084 290.304C318.962 290.093 318.901 289.841 318.901 289.549V289.46C318.901 289.168 318.962 288.916 319.084 288.705C319.21 288.494 319.38 288.333 319.595 288.222C319.813 288.111 320.06 288.056 320.333 288.056C320.607 288.056 320.851 288.111 321.066 288.222C321.281 288.333 321.449 288.494 321.571 288.705C321.697 288.916 321.76 289.168 321.76 289.46V289.549C321.76 289.841 321.697 290.093 321.571 290.304C321.449 290.511 321.281 290.672 321.066 290.787C320.851 290.898 320.607 290.953 320.333 290.953ZM320.333 290.387C320.567 290.387 320.757 290.313 320.905 290.165C321.053 290.013 321.127 289.803 321.127 289.532V289.477C321.127 289.207 321.053 288.998 320.905 288.85C320.757 288.698 320.567 288.622 320.333 288.622C320.1 288.622 319.91 288.698 319.762 288.85C319.614 288.998 319.54 289.207 319.54 289.477V289.532C319.54 289.803 319.614 290.013 319.762 290.165C319.91 290.313 320.1 290.387 320.333 290.387ZM323.56 290.953C323.338 290.953 323.131 290.9 322.938 290.792C322.746 290.681 322.592 290.52 322.478 290.31C322.363 290.099 322.306 289.845 322.306 289.549V289.46C322.306 289.164 322.363 288.911 322.478 288.7C322.592 288.489 322.744 288.33 322.933 288.222C323.125 288.111 323.334 288.056 323.56 288.056C323.73 288.056 323.875 288.076 323.993 288.117C324.111 288.158 324.206 288.209 324.276 288.272C324.35 288.335 324.408 288.404 324.448 288.478H324.543V286.99H325.175V290.876H324.554V290.515H324.459C324.393 290.626 324.291 290.728 324.154 290.82C324.017 290.909 323.819 290.953 323.56 290.953ZM323.749 290.398C323.978 290.398 324.169 290.324 324.321 290.176C324.472 290.025 324.548 289.81 324.548 289.532V289.477C324.548 289.196 324.472 288.981 324.321 288.833C324.173 288.685 323.982 288.611 323.749 288.611C323.519 288.611 323.327 288.685 323.172 288.833C323.02 288.981 322.944 289.196 322.944 289.477V289.532C322.944 289.81 323.02 290.025 323.172 290.176C323.327 290.324 323.519 290.398 323.749 290.398ZM327.239 290.953C326.965 290.953 326.722 290.896 326.511 290.781C326.304 290.663 326.141 290.498 326.023 290.287C325.908 290.073 325.851 289.823 325.851 289.538V289.471C325.851 289.183 325.908 288.933 326.023 288.722C326.138 288.511 326.299 288.348 326.506 288.233C326.713 288.115 326.952 288.056 327.222 288.056C327.488 288.056 327.721 288.115 327.921 288.233C328.121 288.348 328.277 288.511 328.388 288.722C328.499 288.933 328.554 289.179 328.554 289.46V289.688H326.495C326.502 289.902 326.578 290.075 326.722 290.204C326.867 290.334 327.044 290.398 327.255 290.398C327.462 290.398 327.616 290.354 327.716 290.265C327.816 290.173 327.892 290.069 327.944 289.954L328.471 290.226C328.419 290.326 328.343 290.434 328.243 290.548C328.147 290.659 328.018 290.755 327.855 290.837C327.692 290.915 327.487 290.953 327.239 290.953ZM326.5 289.205H327.905C327.89 289.024 327.82 288.879 327.694 288.772C327.572 288.665 327.412 288.611 327.216 288.611C327.013 288.611 326.85 288.665 326.728 288.772C326.606 288.879 326.53 289.024 326.5 289.205ZM329.209 290.876V288.134H329.837V288.45H329.931C329.972 288.335 330.04 288.252 330.136 288.2C330.233 288.148 330.347 288.122 330.481 288.122H330.814V288.689H330.47C330.285 288.689 330.135 288.739 330.02 288.839C329.905 288.935 329.848 289.085 329.848 289.288V290.876H329.209ZM332.157 290.953C331.964 290.953 331.79 290.92 331.635 290.854C331.479 290.783 331.355 290.683 331.263 290.554C331.174 290.424 331.13 290.265 331.13 290.076C331.13 289.891 331.174 289.736 331.263 289.61C331.355 289.484 331.481 289.39 331.64 289.327C331.8 289.26 331.981 289.227 332.184 289.227H332.978V289.061C332.978 288.916 332.934 288.8 332.845 288.711C332.756 288.618 332.617 288.572 332.429 288.572C332.244 288.572 332.103 288.616 332.007 288.705C331.914 288.79 331.853 288.901 331.824 289.038L331.235 288.844C331.28 288.7 331.35 288.568 331.446 288.45C331.546 288.332 331.677 288.237 331.84 288.167C332.003 288.093 332.203 288.056 332.44 288.056C332.799 288.056 333.08 288.146 333.283 288.328C333.491 288.505 333.594 288.765 333.594 289.105V290.182C333.594 290.293 333.646 290.348 333.75 290.348H333.983V290.876H333.533C333.4 290.876 333.291 290.842 333.206 290.776C333.121 290.709 333.078 290.619 333.078 290.504V290.493H332.984C332.962 290.545 332.923 290.607 332.867 290.681C332.812 290.755 332.727 290.82 332.612 290.876C332.501 290.928 332.349 290.953 332.157 290.953ZM332.262 290.432C332.473 290.432 332.645 290.372 332.778 290.254C332.912 290.132 332.978 289.969 332.978 289.766V289.71H332.223C332.086 289.71 331.975 289.74 331.89 289.799C331.805 289.858 331.763 289.945 331.763 290.06C331.763 290.171 331.807 290.261 331.896 290.332C331.985 290.398 332.107 290.432 332.262 290.432ZM335.36 290.876C335.182 290.876 335.039 290.824 334.932 290.72C334.828 290.613 334.777 290.469 334.777 290.287V288.661H334.061V288.134H334.777V287.251H335.415V288.134H336.203V288.661H335.415V290.182C335.415 290.293 335.467 290.348 335.57 290.348H336.12V290.876H335.36ZM338.01 290.953C337.736 290.953 337.494 290.896 337.283 290.781C337.075 290.663 336.913 290.498 336.794 290.287C336.679 290.073 336.622 289.823 336.622 289.538V289.471C336.622 289.183 336.679 288.933 336.794 288.722C336.909 288.511 337.07 288.348 337.277 288.233C337.484 288.115 337.723 288.056 337.993 288.056C338.26 288.056 338.493 288.115 338.693 288.233C338.892 288.348 339.048 288.511 339.159 288.722C339.27 288.933 339.325 289.179 339.325 289.46V289.688H337.266C337.273 289.902 337.349 290.075 337.494 290.204C337.638 290.334 337.816 290.398 338.027 290.398C338.234 290.398 338.387 290.354 338.487 290.265C338.587 290.173 338.663 290.069 338.715 289.954L339.242 290.226C339.19 290.326 339.115 290.434 339.015 290.548C338.918 290.659 338.789 290.755 338.626 290.837C338.463 290.915 338.258 290.953 338.01 290.953ZM337.272 289.205H338.676C338.661 289.024 338.591 288.879 338.465 288.772C338.343 288.665 338.184 288.611 337.988 288.611C337.784 288.611 337.621 288.665 337.499 288.772C337.377 288.879 337.301 289.024 337.272 289.205Z"
        fill="#24292F"
      />
      <circle cx={306.817} cy={288.651} r={2.08162} fill="#0969DA" />
      <g filter="url(#filter4_dd_6063_36504)">
        <path
          d="M347.965 213.713H301.753C300.719 213.713 299.88 214.552 299.88 215.587V228.493C299.88 229.527 300.719 230.366 301.753 230.366H347.965C349 230.366 349.839 229.527 349.839 228.493V215.587C349.839 214.552 349 213.713 347.965 213.713Z"
          fill="white"
        />
        <path
          d="M301.753 214.06H347.965C348.808 214.06 349.492 214.744 349.492 215.587V228.493C349.492 229.336 348.808 230.019 347.965 230.019H301.753C300.91 230.019 300.227 229.336 300.227 228.493V215.587C300.227 214.744 300.91 214.06 301.753 214.06Z"
          stroke="#E5E5E5"
          strokeWidth={0.693873}
        />
      </g>
      <path
        d="M347.565 199.74L348.753 202.828L351.832 204.008L348.753 205.196L347.565 208.275L346.377 205.196L343.298 204.008L346.386 202.828L347.565 199.74Z"
        fill="#129ED9"
      />
      <path
        d="M366.186 272.571L367.192 275.19L369.812 276.205L367.192 277.211L366.186 279.83L365.18 277.211L362.561 276.205L365.18 275.19L366.186 272.571Z"
        fill="#129ED9"
      />
      <path
        d="M300.946 268.616L301.736 270.671L303.791 271.461L301.736 272.25L300.946 274.305L300.157 272.25L298.102 271.461L300.157 270.671L300.946 268.616Z"
        fill="#129ED9"
      />
      <path
        d="M205.079 253.22H202.737M220.951 253.22H212.711M323.61 253.22H310.704H270.043H226.198M250.111 271.599H246.772M294.163 271.599H257.067M245.297 235.986H291.674H317.226V232.448"
        stroke="#D1ECFE"
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M205.079 253.22H202.737M220.951 253.22H212.711M323.61 253.22H310.704H270.043H226.198M250.111 271.599H246.772M294.163 271.599H257.067M245.297 235.986H291.674H317.226V232.448"
        stroke="#18A0FB"
        strokeOpacity={0.2}
        strokeWidth={1.04081}
        strokeMiterlimit={10}
      />
      <path
        d="M305.603 224.121L308.032 219.958L310.46 224.121H305.603Z"
        fill="#CF222E"
      />
      <path
        d="M316.987 224.342C316.513 224.342 316.136 224.209 315.855 223.942C315.573 223.672 315.433 223.285 315.433 222.782V221.86C315.433 221.357 315.573 220.972 315.855 220.706C316.136 220.436 316.513 220.301 316.987 220.301C317.461 220.301 317.825 220.43 318.081 220.689C318.34 220.948 318.469 221.304 318.469 221.755V221.788H317.814V221.738C317.814 221.494 317.746 221.294 317.609 221.139C317.475 220.98 317.268 220.9 316.987 220.9C316.713 220.9 316.497 220.985 316.338 221.155C316.182 221.322 316.104 221.553 316.104 221.849V222.793C316.104 223.085 316.182 223.317 316.338 223.487C316.497 223.657 316.713 223.742 316.987 223.742C317.268 223.742 317.475 223.665 317.609 223.509C317.746 223.35 317.814 223.148 317.814 222.904V222.81H318.469V222.887C318.469 223.339 318.34 223.694 318.081 223.953C317.825 224.212 317.461 224.342 316.987 224.342ZM319.116 224.264V221.522H319.743V221.838H319.838C319.879 221.724 319.947 221.64 320.043 221.588C320.139 221.537 320.254 221.511 320.387 221.511H320.72V222.077H320.376C320.191 222.077 320.041 222.127 319.927 222.227C319.812 222.323 319.755 222.473 319.755 222.676V224.264H319.116ZM321.285 224.264V221.522H321.923V224.264H321.285ZM321.601 221.172C321.486 221.172 321.386 221.135 321.301 221.061C321.22 220.983 321.179 220.882 321.179 220.756C321.179 220.63 321.22 220.53 321.301 220.456C321.386 220.378 321.486 220.339 321.601 220.339C321.723 220.339 321.823 220.378 321.901 220.456C321.982 220.53 322.023 220.63 322.023 220.756C322.023 220.882 321.982 220.983 321.901 221.061C321.823 221.135 321.723 221.172 321.601 221.172ZM323.776 224.264C323.598 224.264 323.455 224.212 323.348 224.109C323.244 224.001 323.193 223.857 323.193 223.676V222.049H322.477V221.522H323.193V220.639H323.831V221.522H324.619V222.049H323.831V223.57C323.831 223.681 323.883 223.737 323.986 223.737H324.536V224.264H323.776ZM325.269 224.264V221.522H325.907V224.264H325.269ZM325.585 221.172C325.471 221.172 325.371 221.135 325.286 221.061C325.204 220.983 325.163 220.882 325.163 220.756C325.163 220.63 325.204 220.53 325.286 220.456C325.371 220.378 325.471 220.339 325.585 220.339C325.707 220.339 325.807 220.378 325.885 220.456C325.966 220.53 326.007 220.63 326.007 220.756C326.007 220.882 325.966 220.983 325.885 221.061C325.807 221.135 325.707 221.172 325.585 221.172ZM327.999 224.342C327.732 224.342 327.492 224.286 327.277 224.175C327.062 224.064 326.892 223.903 326.766 223.692C326.644 223.481 326.583 223.228 326.583 222.932V222.854C326.583 222.558 326.644 222.305 326.766 222.094C326.892 221.883 327.062 221.722 327.277 221.611C327.492 221.5 327.732 221.444 327.999 221.444C328.261 221.444 328.485 221.49 328.67 221.583C328.859 221.675 329.011 221.803 329.125 221.966C329.24 222.125 329.314 222.305 329.347 222.504L328.731 222.632C328.716 222.517 328.681 222.414 328.626 222.321C328.57 222.225 328.491 222.149 328.387 222.094C328.287 222.038 328.163 222.01 328.015 222.01C327.863 222.01 327.727 222.044 327.604 222.11C327.486 222.173 327.392 222.269 327.321 222.399C327.255 222.528 327.221 222.684 327.221 222.865V222.921C327.221 223.102 327.255 223.257 327.321 223.387C327.392 223.513 327.486 223.609 327.604 223.676C327.727 223.742 327.863 223.776 328.015 223.776C328.241 223.776 328.411 223.718 328.526 223.603C328.644 223.485 328.718 223.333 328.748 223.148L329.364 223.293C329.32 223.485 329.24 223.661 329.125 223.82C329.011 223.979 328.859 224.107 328.67 224.203C328.485 224.295 328.261 224.342 327.999 224.342ZM330.834 224.342C330.642 224.342 330.468 224.308 330.313 224.242C330.157 224.172 330.033 224.072 329.941 223.942C329.852 223.813 329.807 223.653 329.807 223.465C329.807 223.28 329.852 223.124 329.941 222.998C330.033 222.873 330.159 222.778 330.318 222.715C330.477 222.649 330.659 222.615 330.862 222.615H331.656V222.449C331.656 222.305 331.612 222.188 331.523 222.099C331.434 222.007 331.295 221.96 331.106 221.96C330.921 221.96 330.781 222.005 330.685 222.094C330.592 222.179 330.531 222.29 330.501 222.427L329.913 222.232C329.957 222.088 330.028 221.957 330.124 221.838C330.224 221.72 330.355 221.625 330.518 221.555C330.681 221.481 330.881 221.444 331.117 221.444C331.476 221.444 331.758 221.535 331.961 221.716C332.168 221.894 332.272 222.153 332.272 222.493V223.57C332.272 223.681 332.324 223.737 332.428 223.737H332.661V224.264H332.211C332.078 224.264 331.969 224.231 331.884 224.164C331.798 224.098 331.756 224.007 331.756 223.892V223.881H331.661C331.639 223.933 331.6 223.996 331.545 224.07C331.489 224.144 331.404 224.209 331.29 224.264C331.179 224.316 331.027 224.342 330.834 224.342ZM330.94 223.82C331.151 223.82 331.323 223.761 331.456 223.642C331.589 223.52 331.656 223.357 331.656 223.154V223.098H330.901C330.764 223.098 330.653 223.128 330.568 223.187C330.483 223.246 330.44 223.333 330.44 223.448C330.44 223.559 330.485 223.65 330.573 223.72C330.662 223.787 330.784 223.82 330.94 223.82ZM333.189 224.264V220.378H333.827V224.264H333.189Z"
        fill="#24292F"
      />
      <path
        d="M147.573 70.775L147.573 241.468"
        stroke="#E5E5E5"
        strokeWidth={0.693873}
      />
      <g filter="url(#filter5_dd_6063_36504)">
        <rect
          x={27.8809}
          y={186.478}
          width={110.256}
          height={35.0407}
          rx={1.87346}
          fill="white"
        />
        <rect
          x={28.2278}
          y={186.825}
          width={109.563}
          height={34.3468}
          rx={1.52652}
          stroke="#E5E5E5"
          strokeWidth={0.693873}
        />
        <path
          d="M42.7228 208.156C40.9231 208.156 39.6709 207.223 39.6709 205.884V205.874C39.6709 204.871 40.4027 204.095 41.4435 203.884V203.852C40.5491 203.613 39.9528 202.957 39.9528 202.117V202.106C39.9528 200.903 41.102 200.019 42.7228 200.019C44.3437 200.019 45.4929 200.903 45.4929 202.106V202.117C45.4929 202.957 44.8966 203.613 44.0022 203.852V203.884C45.0484 204.095 45.7748 204.871 45.7748 205.874V205.884C45.7748 207.223 44.5226 208.156 42.7228 208.156ZM42.7228 203.407C43.5414 203.407 44.1106 202.93 44.1106 202.247V202.236C44.1106 201.553 43.5414 201.076 42.7228 201.076C41.9043 201.076 41.3351 201.553 41.3351 202.236V202.247C41.3351 202.93 41.9043 203.407 42.7228 203.407ZM42.7228 207.088C43.6606 207.088 44.3274 206.546 44.3274 205.792V205.781C44.3274 205.022 43.6661 204.475 42.7228 204.475C41.7742 204.475 41.1183 205.022 41.1183 205.781V205.792C41.1183 206.546 41.785 207.088 42.7228 207.088ZM47.6233 207.999L51.0222 201.407V201.32H46.9891V200.176H52.4316V201.342L49.087 207.999H47.6233ZM55.4999 204.399C54.4048 204.399 53.7435 203.57 53.7435 202.236V202.231C53.7435 200.897 54.4048 200.068 55.4999 200.068C56.5895 200.068 57.2562 200.897 57.2562 202.231V202.236C57.2562 203.57 56.5895 204.399 55.4999 204.399ZM56.4756 207.999H55.3589L60.6443 200.176H61.761L56.4756 207.999ZM55.4999 203.613C55.9932 203.613 56.2805 203.109 56.2805 202.236V202.231C56.2805 201.353 55.9932 200.854 55.4999 200.854C55.0011 200.854 54.7247 201.353 54.7247 202.231V202.236C54.7247 203.109 55.0011 203.613 55.4999 203.613ZM61.62 208.107C60.525 208.107 59.8583 207.272 59.8583 205.939V205.933C59.8583 204.6 60.525 203.776 61.62 203.776C62.7096 203.776 63.3764 204.6 63.3764 205.933V205.939C63.3764 207.272 62.7096 208.107 61.62 208.107ZM61.62 207.321C62.1133 207.321 62.4006 206.817 62.4006 205.939V205.933C62.4006 205.06 62.1133 204.562 61.62 204.562C61.1213 204.562 60.8394 205.06 60.8394 205.933V205.939C60.8394 206.817 61.1213 207.321 61.62 207.321Z"
          fill="#1A7F37"
        />
        <rect
          x={69.9785}
          y={194.805}
          width={60.102}
          height={18.3877}
          rx={9.19387}
          fill="#D1ECFD"
        />
        <rect
          x={70.3255}
          y={195.152}
          width={59.4081}
          height={17.6939}
          rx={8.84694}
          stroke="#18A0FB"
          strokeOpacity={0.3}
          strokeWidth={0.693873}
        />
        <path
          d="M77.5332 206.499L76.1171 201.218H77.1014L78.0052 205.181H78.0601L79.0993 201.218H79.9372L80.991 205.181H81.0422L81.946 201.218H82.923L81.5069 206.499H80.6214L79.5457 202.719H79.4908L78.4223 206.499H77.5332ZM85.9015 206.63C84.4049 206.63 83.4755 205.569 83.4755 203.864V203.857C83.4755 202.144 84.4013 201.087 85.8979 201.087C87.098 201.087 88.0092 201.848 88.1336 202.927V202.957H87.2078L87.2042 202.942C87.0688 202.316 86.5638 201.903 85.8979 201.903C85.0014 201.903 84.4415 202.653 84.4415 203.853V203.86C84.4415 205.064 85.0014 205.814 85.9015 205.814C86.5711 205.814 87.0688 205.441 87.2042 204.859L87.2078 204.841H88.1336V204.867C87.9945 205.924 87.12 206.63 85.9015 206.63ZM88.6349 206.499L90.5083 201.218H91.5731L93.4466 206.499H92.4586L92.0159 205.134H90.0619L89.6228 206.499H88.6349ZM91.0096 202.199L90.2998 204.406H91.7817L91.0718 202.199H91.0096ZM96.3629 206.63C94.8334 206.63 93.882 205.565 93.882 203.86V203.853C93.882 202.166 94.8444 201.087 96.3482 201.087C97.5667 201.087 98.4449 201.786 98.6242 202.817L98.6279 202.854H97.6911L97.6802 202.817C97.5082 202.239 97.0252 201.903 96.3482 201.903C95.4262 201.903 94.8444 202.653 94.8444 203.846V203.853C94.8444 205.064 95.4371 205.814 96.3775 205.814C97.1825 205.814 97.7314 205.313 97.7424 204.563L97.746 204.453H96.48V203.732H98.6718V204.391C98.6718 205.756 97.7716 206.63 96.3629 206.63ZM101.669 206.499V205.862L103.403 204.091C104.12 203.366 104.321 203.099 104.321 202.693V202.682C104.321 202.195 103.988 201.844 103.44 201.844C102.88 201.844 102.503 202.214 102.503 202.759L102.499 202.774L101.621 202.77L101.617 202.759C101.617 201.775 102.386 201.087 103.487 201.087C104.515 201.087 105.254 201.712 105.254 202.602V202.613C105.254 203.213 104.965 203.688 104.003 204.614L102.946 205.639V205.715H105.335V206.499H101.669ZM106.989 206.572C106.656 206.572 106.407 206.319 106.407 205.994C106.407 205.668 106.656 205.415 106.989 205.415C107.326 205.415 107.571 205.668 107.571 205.994C107.571 206.319 107.326 206.572 106.989 206.572ZM109.752 206.499V202.148H109.689L108.376 203.077V202.188L109.755 201.218H110.696V206.499H109.752ZM113.868 206.499L115.741 201.218H116.806L118.68 206.499H117.692L117.249 205.134H115.295L114.856 206.499H113.868ZM116.243 202.199L115.533 204.406H117.015L116.305 202.199H116.243ZM119.196 206.499L121.069 201.218H122.134L124.007 206.499H123.019L122.577 205.134H120.623L120.184 206.499H119.196ZM121.57 202.199L120.861 204.406H122.342L121.633 202.199H121.57Z"
          fill="#24292F"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_6063_36504"
        x={45.1432}
        y={37.4135}
        width={306.859}
        height={223.594}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.610609} />
        <feGaussianBlur stdDeviation={0.915913} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.105882 0 0 0 0 0.121569 0 0 0 0 0.141176 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6063_36504"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4.88487} />
        <feGaussianBlur stdDeviation={7.3273} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.290196 0 0 0 0 0.32549 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6063_36504"
          result="effect2_dropShadow_6063_36504"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6063_36504"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_6063_36504"
        x={170.818}
        y={19.4284}
        width={111.02}
        height={109.632}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1.38775} />
        <feGaussianBlur stdDeviation={2.08162} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.156863 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6063_36504"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11.102} />
        <feGaussianBlur stdDeviation={16.653} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.290196 0 0 0 0 0.32549 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6063_36504"
          result="effect2_dropShadow_6063_36504"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6063_36504"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dd_6063_36504"
        x={294.328}
        y={216.489}
        width={141.55}
        height={94.3667}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1.38775} />
        <feGaussianBlur stdDeviation={2.08162} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.156863 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6063_36504"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11.102} />
        <feGaussianBlur stdDeviation={16.653} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.290196 0 0 0 0 0.32549 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6063_36504"
          result="effect2_dropShadow_6063_36504"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6063_36504"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_dd_6063_36504"
        x={265.185}
        y={255.345}
        width={124.897}
        height={88.8158}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1.38775} />
        <feGaussianBlur stdDeviation={2.08162} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.156863 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6063_36504"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11.102} />
        <feGaussianBlur stdDeviation={16.653} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.290196 0 0 0 0 0.32549 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6063_36504"
          result="effect2_dropShadow_6063_36504"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6063_36504"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_dd_6063_36504"
        x={266.574}
        y={191.509}
        width={116.571}
        height={83.2648}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1.38775} />
        <feGaussianBlur stdDeviation={2.08162} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.156863 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6063_36504"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11.102} />
        <feGaussianBlur stdDeviation={16.653} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.290196 0 0 0 0 0.32549 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6063_36504"
          result="effect2_dropShadow_6063_36504"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6063_36504"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_dd_6063_36504"
        x={-5.42506}
        y={164.274}
        width={176.869}
        height={101.653}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1.38775} />
        <feGaussianBlur stdDeviation={2.08162} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.156863 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6063_36504"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11.102} />
        <feGaussianBlur stdDeviation={16.653} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.290196 0 0 0 0 0.32549 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6063_36504"
          result="effect2_dropShadow_6063_36504"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6063_36504"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_6063_36504">
        <rect
          width={421.875}
          height={316.406}
          fill="white"
          transform="translate(0.125)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default AccessibilityIllustration;
